import {initElements} from "../define/shared";

export default function initCommentForm() {
    initElements(".singlePage .commentsForm", commentForm => {
        const postId = commentForm.dataset.postId;
        const noButton = commentForm.querySelector(".noButton");
        const yesButton = commentForm.querySelector(".yesButton");
        const fieldBox = commentForm.querySelector(".commentsForm-field");
        const textarea = commentForm.querySelector("#comment");
        const submitBtn = commentForm.querySelector(".commentsForm-submit");
        const loader = commentForm.querySelector(".loader");

        yesButton.addEventListener("click", () => {
            yesButton.classList.add("is--active");
            noButton.setAttribute("disabled", "");
            sendFeedback(1);
        });

        noButton.addEventListener("click", () => {
            fieldBox.classList.add("is--open");
            noButton.classList.add("is--active");
            yesButton.setAttribute("disabled", "");
        });

        textarea.addEventListener("input", () => {
            textarea.value.length > 5 ? submitBtn.removeAttribute("disabled") : submitBtn.setAttribute("disabled", "");
        });

        submitBtn.addEventListener("click", () => {
            sendFeedback(0);
        });

        function sendFeedback($feedback) {
            loader.classList.add("is--active");
            commentForm.classList.add("is--loading");

            fetch(window.RES.base + "wa-theme/v1/post-comment", {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    "X-WP-Nonce": window.RES.nonce_wp,
                },
                body: JSON.stringify({
                    postId: commentForm.dataset.postId,
                    comment: textarea.value,
                    nonce: window.RES.nonce,
                    feedback: $feedback
                })
            })
                .then(response => response.json())
                .then(data => {
                    loader.classList.remove("is--active");
                    commentForm.classList.remove("is--loading");

                    if (data.success) {
                        const text = $feedback === 1 ? "Tack för din återkoppling." : "Tack för din synpunkt.";
                        fieldBox.innerHTML = `<p class='success response'>${text}</p>`;
                    } else {
                        const p = document.createElement("p");
                        p.classList.add("error", "response");
                        p.innerText = "Något gick fel, försök igen.";
                        fieldBox.append(p);
                    }

                    fieldBox.classList.add("is--open");
                });
        }
    });
}
